import { FunctionComponent, ReactNode } from 'react';
import Parser from 'html-react-parser';
import l from '../../../../lang';
import { openNewTabAndFocus } from '../../../../utils';
import ButtonLink from '../../../common/button-link';
import { Urls } from '../../../../config/urls';
import { segmentIntegrationsShopifyPageLinkDocs } from '../../../../utils/analytics';

export const ShopifyTransparent: FunctionComponent<{ children: ReactNode }> = ({ children }) => (
  <>
    <div className="add-to-shopify__desc">
      <div>{l('paymentIntegration.shopify.desc.transparent')}</div>
      <p>
        <ButtonLink
          text={l('paymentIntegration.moreInfo.ourDocumentation.transparent')}
          onClick={() => {
            segmentIntegrationsShopifyPageLinkDocs();
            openNewTabAndFocus(Urls.docs.shopifyIntegration)
          }}
        />
        <span>{Parser(l('paymentIntegration.moreInfo.transparent'))} </span>
      </p>
    </div>
    {children}
  </>
);
